import React from "react";
import { strings } from "../../strings/strings";
import { Button } from "../ui";

function DeletModel(props) {
  const { handleConfirmDelete, handleCancelDelete, isLoading = false } = props;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-sm w-full shadow-lg">
        <h2 className="text-lg font-semibold mb-4">{strings.confirmDeleteTitle}</h2>
        <p className="text-sm mb-6">{strings.areyousureyouwanttodelete}</p>
        <div className="flex justify-end gap-3">
          <Button 
            variant="danger"
            onClick={handleConfirmDelete}
            isLoading={isLoading}
            disabled={isLoading}
          >
            {strings.ok}
          </Button>
          <Button 
            variant="outline"
            onClick={handleCancelDelete}
            disabled={isLoading}
          >
            {strings.cancel}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default DeletModel;
